import HttpErrorMixin from './HttpErrorMixin';
import { message } from '@grininc/grin-ui';
import ActivationBriefStepsMixin from './ActivationBriefStepsMixin';
import ActivationBriefMixin from './ActivationBriefMixin';
import ActivationBriefFieldsMixin from './ActivationBriefFieldsMixin';
import ContactsMixin from './ContactsMixin';
import LocationsMixin from './LocationsMixin';

export default {
    mixins: [
        //@TODO: move mixins set to specific provider definition
        ActivationBriefMixin,
        ActivationBriefStepsMixin,
        ActivationBriefFieldsMixin,
        ContactsMixin,
        HttpErrorMixin,
        LocationsMixin
    ],
    data() {
        return {
            errorMessage: null,
            errors: {},
            isLoading: false
        };
    },
    props: {
        tag: {
            type: String,
            default: 'div'
        }
    },
    methods: {
        handleHttpError(error, type = 'step') {
            if (error.status === 422) {
                this.errors = error.data.errors;
                this.errorMessage = error.data.message;
            } else if (error.status === 409) {
                if (type === 'step') {
                    return this.updateStep(error.data);
                } else if (type === 'brief') {
                    this.handleConflictError(error);
                } else if (type === 'delivery') {
                    this.handleDeliveryError(error);
                } else {
                    return this.handleGenericError(error);
                }
            } else if (error.status === 423) {
                return this.handleLockedException(error.data);
            } else {
                return this.handleGenericError(error);
            }
        },
        handleGenericError(error) {
            console.error(error);
            if (error.name !== 'NavigationDuplicated') {
                message.error('Something went wrong, please try again or contact support');
            }
        },

        handleDeliveryError(error) {
            this.errorMessage = error?.data?.message;
        },

        resetErrors() {
            this.errorMessage = null;
            this.errors = {};
        }
    }
};
